__turbopack_context__.v({
  "dropdown": "Select-module-sass-module__oQbd1W__dropdown",
  "dropdown__item": "Select-module-sass-module__oQbd1W__dropdown__item",
  "dropdown__link": "Select-module-sass-module__oQbd1W__dropdown__link",
  "dropdown__list": "Select-module-sass-module__oQbd1W__dropdown__list",
  "dropdown__shadow": "Select-module-sass-module__oQbd1W__dropdown__shadow",
  "field": "Select-module-sass-module__oQbd1W__field",
  "field__arrow": "Select-module-sass-module__oQbd1W__field__arrow",
  "field__value": "Select-module-sass-module__oQbd1W__field__value",
  "field__value--placeholder": "Select-module-sass-module__oQbd1W__field__value--placeholder",
  "wrapper": "Select-module-sass-module__oQbd1W__wrapper",
});
